import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import { OptionsObject, SnackbarKey, useSnackbar, VariantType } from 'notistack'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  closeButton: {
    color: theme.palette.grey['100'],
  },
}))

type EnqueueSnackbar = (message: string) => SnackbarKey
type CloseSnackbar = (key: SnackbarKey) => void

type UseNotifications = {
  enqueueInfo: EnqueueSnackbar
  enqueueSuccess: EnqueueSnackbar
  enqueueWarning: EnqueueSnackbar
  enqueueError: EnqueueSnackbar
  closeSnackbar: CloseSnackbar
}

export function useNotifications(): UseNotifications {
  const classes = useStyles()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const createOptions = (variant: VariantType): OptionsObject => ({
    variant,
    action: (key: SnackbarKey): React.ReactElement => (
      <Button
        data-cy={`close-${variant}-notification`}
        className={classes.closeButton}
        onClick={() => closeSnackbar(key)}
      >
        {t('common.close')}
      </Button>
    ),
  })

  const enqueueInfo = (message: string) =>
    enqueueSnackbar(message, createOptions('info'))

  const enqueueSuccess = (message: string) =>
    enqueueSnackbar(message, createOptions('success'))

  const enqueueWarning = (message: string) =>
    enqueueSnackbar(message, createOptions('warning'))

  const enqueueError = (message: string) =>
    enqueueSnackbar(message, createOptions('error'))

  return {
    enqueueInfo,
    enqueueSuccess,
    enqueueWarning,
    enqueueError,
    closeSnackbar,
  }
}
